import * as identify from "utils/treeUtils";
import type { NodeApi } from "@hogartrabe/react-arborist-vrh";

export const containsConfig = (node: NodeApi) => {
  if (identify.isAnyProduct(node.data)) {
    return true;
  }
  if (!node.children || node.children.length === 0) {
    return false;
  }

  for (const child of node.children) {
    if (containsConfig(child)) {
      return true;
    }
  }

  return false;
};
